import { createGlobalStyle } from 'styled-components';

export const GlobalStyleWrapper = createGlobalStyle`
  body {
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 16px;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
  }

  button {
    outline: none;
    border-radius: 0;
    border: 0 solid transparent;
    background-color: transparent;
  }
  
  a {
    text-decoration: none;
  }
`;
